import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ADMIN_URL, EVENT_URL, PRODUCT_URL } from "../../../helpers/api.routes";
import { multipartFormData } from "../../../helpers/api.services";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { AdminEventCategoryService } from "../../eventCategory/service";
import { CreateForm } from "./CreateForm";
import { AdminProductCategoryService } from "../../productCategory/service";
export const CreateProduct = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [categories, setCategories] = useState();
  const [state, setState] = useState<any>({
    website: "",
    title: "",
    price: null,
    category: { website: "", name: "", imageName: "" },
    isActive: false,
    image: undefined,
  });
  const [image, setImage] = useState<File>();
  const submitHandler = () => {
    if (state?.id) {
      multipartFormData(
        image,
        `${PRODUCT_URL}/${state?.id}`,
        JSON.stringify({
          ...state,
          category: state?.category,
        }),
        "post"
      )
        .then((response) => {
          SuccessToast(t(`event.successfully_updated`));

          setTriggerUpdate(!triggerUpdate);
        })
        .catch((error) => ErrorToast(error));
    } else {
      multipartFormData(
        image,
        `${PRODUCT_URL}`,
        JSON.stringify({
          ...state,
          category: state?.category,
        }),
        "post"
      )
        .then((response) => {
          SuccessToast(t(`event.successfully_created`));

          setTriggerUpdate(!triggerUpdate);

          navigate("/admin/product");
        })
        .catch((error) => ErrorToast(error));
    }
  };

  useEffect(() => {
    AdminProductCategoryService.getAll({
      page: 1,
      perPage: 0,
      active: "active",
    })
      .then((response) => {
        const { data } = response;
        setCategories(data?.items);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  return (
    <div className="col-12">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          submitHandler();
        }}
      >
        <CreateForm
          setImage={setImage}
          categories={categories!}
          state={state}
          setState={setState}
        />
      </Form>
    </div>
  );
};
